import React, { Component } from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import {
  getThemeImages,
  LightThemeColors,
  withTheme,
} from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import PermissionsDescriptionSection from '../../PermissionsDescriptionSection/PermissionsDescriptionSection';
import PermissionsItem from '../../PermissionsItem/PermissionsItem';
import { SectionEnums } from '../PrivacyPermissionsOverlay.Enums';
import styles from '../PrivacyPermissionsOverlay.styles';

class PrivacyPermissionsSection extends Component {
  renderTitle = () => {
    const notFirst = this.props.index > 0;

    return (
      <VFText
        style={[styles.sectionTitle, notFirst && styles.sectionTitleSml]}
        localize={false}
        i18nKey={this.props.section.title}
        testKey={FrameworkTestKeys.PPOSectionTitle}
      />
    );
  };

  renderActions = hasActions => {
    return (
      hasActions && (
        <View
          style={styles.sectionActionsContainer}
          testID={FrameworkTestKeys.PPOSectionActionsView}
        >
          {this.props.section.actions?.type === SectionEnums.CHECK
            ? this.renderCheckItems()
            : this.renderPermissionItems()}
        </View>
      )
    );
  };

  renderCheckItems = () => {
    const { section, theme } = this.props;
    const images = getThemeImages(theme.name);

    return section.actions.items.map((item, i) => (
      <View
        key={i}
        style={styles.checkItemContainer}
        testID={FrameworkTestKeys.PPOSectionItemsView}
      >
        <Icon
          name={images.ic_tick_solved}
          type="image"
          size={26}
          style={styles.checkItemIcon}
          testID={FrameworkTestKeys.PPOSectionItemsIcon}
        />

        <VFText
          i18nKey={item.title}
          style={styles.checkItemTitle}
          testID={FrameworkTestKeys.PPOSectionItemsTitle}
        />
      </View>
    ));
  };

  renderPermissionItems = () => {
    const { items, theme } = this.props.section.actions;

    return items.map((item, i) => (
      <PermissionsItem
        key={i}
        style={styles.toggleContainer(items.length - 1 === i)}
        icon={item.icon}
        title={item.title}
        description={item.description}
        descriptionStyle={styles.toggleDiscription}
        closed={item.closed}
        initialValue={item.initialValue}
        onAcceptanceChange={() => item.onToggle?.(item.key || item.title)}
        isLast={items.length - 1 === i}
        theme={theme}
      />
    ));
  };

  render() {
    const { section, theme } = this.props;

    return (
      <View style={{ backgroundColor: theme.colors.backgroundColor }}>
        {this.renderTitle()}

        {section.renderContent ? (
          section.renderContent()
        ) : (
          <PermissionsDescriptionSection section={section} />
        )}

        {this.renderActions(section.actions)}
      </View>
    );
  }
}

PrivacyPermissionsSection.defaultProps = {
  theme: LightThemeColors,
};

PrivacyPermissionsSection.propTypes = {
  section: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  theme: PropTypes.object,
};

export default withTheme(PrivacyPermissionsSection);
